export const showConfirm = (text: string, callback: Function) => {
    const webAppVersion = parseInt(window.Telegram.WebApp.version);

    if (webAppVersion >= 8) {
        window.Telegram.WebApp.showConfirm(text, callback)
    } else console.log('not implemented system interface')
}

export const showAlert = (message: string, callback: Function) => {
    const webAppVersion = parseInt(window.Telegram.WebApp.version);

    if (webAppVersion >= 8) {
        window.Telegram.WebApp.showAlert(message, callback)
    } else console.log('not implemented system interface')
}